import $ from './lib/jquery/jquery.js';
import './lib/jquery/jquery.touchSwipe.js';
import * as CustomInput from './util/CustomInput.ts';

window.$=$; //put undefined to seek missing dependancies

document.addEventListener('touchstart',function(){
  document.body.classList.add('hastouchedscreen');
}, {passive: true, once:true});

export default $;
